import { render } from "./Notification.vue?vue&type=template&id=44cd8f7c"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"

import "./Notification.vue?vue&type=style&index=0&id=44cd8f7c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/NotificationPlugin/Notification.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44cd8f7c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44cd8f7c', __exports__)) {
    api.reload('44cd8f7c', __exports__)
  }
  
  module.hot.accept("./Notification.vue?vue&type=template&id=44cd8f7c", () => {
    api.rerender('44cd8f7c', render)
  })

}


export default __exports__